import React from 'react'
import MyDonation from './MyDonation'
import WebService from 'api/explus-api'

class MyDonationContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filename: '',
      fname:'',
      loading: false,
      hideDeposit: true
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.fileUpload = this.fileUpload.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.hideDeposit = this.hideDeposit.bind(this)
  }

  hideDeposit(method) {
    this.setState({hideDeposit: method});
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    const file = target.files[0];

    this.setState({fname: file['name']});
    this.setState({[name]: file})
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({loading: true})

    this.fileUpload(this.state.filename).then(data => {
      this.setState({loading: false})
    })
  }

  fileUpload(file) {
    const formData = new FormData();
    formData.append('filename',file)

    return WebService.uploadReceipt(formData);
  }

  render() {
    return (
      <MyDonation hide={this.state.hideDeposit} hideDeposit={this.hideDeposit} loading={this.state.loading} fname={this.state.fname} change={this.handleChange} submit={this.handleSubmit}/>
    )
  }
}

export default MyDonationContainer
